<template>
  <!-- 版心内容 -->
  <div class="centerBox">
    <!-- 筛选框 -->
    <div class="InsuranceSelect">
      <el-row type="flex" justify="space-between">
        <el-col :span="20" :offset="0">
          <el-select
            no-data-text="暂无作物"
            clearable
            v-model="selFromData.cropGroupId"
            placeholder="请选择投保作物"
            size="medium"
            @change="selInLists"
          >
            <el-option
              v-for="item in crops"
              :key="item.cropGroupId"
              :label="item.cropGroupName"
              :value="item.cropGroupId"
            >
            </el-option>
          </el-select>

          <el-select
            no-data-text="暂无地块"
            clearable
            @change="selInLists"
            v-model="selFromData.landId"
            placeholder="请选择地块"
            size="medium"
          >
            <el-option
              v-for="item in lands"
              :key="item.id"
              :label="item.landName"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <el-select
            clearable
            @change="selInLists"
            v-model="selFromData.insurePolicyStatus"
            placeholder="请选择保单状态"
            size="medium"
          >
            <el-option
              v-for="item in insureStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-input
            @change="selInLists"
            placeholder="请输入保单号搜索"
            v-model="selFromData.policyNo"
            clearable
            size="medium"
            maxlength="30"
          >
          </el-input>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button
            type="primary"
            size="small"
            @click="buyInsure"
            class="button14"
            >立即投保</el-button
          >
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>

    <!-- 表格 列表组件  有操作按钮 -->

    <table-list
      ref="tabList"
      class="tablelist"
      :list="list"
      :isShow="isShow"
      :loading="loading"
    />

    <!-- 分页 -->
    <pagiation
      :total="total"
      :pageSize="pageSize"
      :pageNo="pageNo"
      @currentChange="currentChange"
      :pagisShow="isShow"
      v-if="isShow"
    />

    <fu-box />
  </div>
</template>

<script>
import TableList from "./TableList.vue";
import {
  getInsurancelist,
  getSeCropGroup,
  getSelectLand,
} from "@/api/request/snkd.produce";
import FuBox from "../compoments/FuBox.vue";
import Pagiation from "@/components/Pagiation.vue";
import sameIn from "@/mixins/listsdetails.js";
import { SessionStorage } from "@/utils/storage";

export default {
  components: { TableList, FuBox, Pagiation },
  name: "InsuranceList",
  mixins: [sameIn],

  data() {
    return {
      // 搜索是否有数据  分页是否显示 -- 是否显示无数图片
      isShow: true,
      loading: true,
      // 投保作物
      crops: [],
      // 地块选择
      lands: [],

      // 保单状态        // 10 已出单 20保障中 30、判陪中  40、未发生理赔 50、理赔成功
      insureStatus: [
        { value: "10", label: "已出单" },
        {
          value: "20",
          label: "保障中",
        },
        {
          value: "30",
          label: "判赔中",
        },
        {
          value: "40",
          label: "未发生理赔",
        },
        {
          value: "41",
          label: "判赔成功",
        },
        {
          value: "50",
          label: "理赔成功",
        },
      ],

      // 保单列表    // 10 已出单 20保障中 30、判陪中  40、未发生理赔 50、理赔成功
      list: [],

      // 获取保单列表参数
      selFromData: {
        // 投保作物
        cropGroupId: "",
        // 状态
        insurePolicyStatus: "",
        // 地块id
        landId: "",
        // 保单号
        policyNo: "",
        insureInfo: {},
      },
    };
  },
  created() {
    this.insureInfo = SessionStorage.get("insureInfo");
    this.getSeCropGroup();
    this.getSelectLand();
    this.getInLists();
  },

  methods: {
    // 筛选
    selInLists() {
      this.pageNo = 1;
      this.getInLists();
    },

    // 获取保单列表
    async getInLists() {
      this.loading = true;
      const { respCode, obj } = await getInsurancelist({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        insureId: this.insureInfo.id,
        ...this.selFromData,
      });
      if (respCode === 0) {
        this.list = obj.list;
        this.total = obj.totalCount;
        if (this.list.length) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
      this.loading = false;
    },

    // 获取投保作物列表
    async getSeCropGroup() {
      const { respCode, obj } = await getSeCropGroup({
        companyId: this.companyId,
        farmId: this.farmId,
        insureId: this.insureInfo.id,
      });
      if (respCode === 0) {
        this.crops = obj;
      }
    },

    // 获取地块
    async getSelectLand() {
      const { respCode, obj } = await getSelectLand({
        companyId: this.companyId,
        farmId: this.farmId,
        insureId: this.insureInfo.id,
      });
      if (respCode === 0) {
        this.lands = obj;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.centerBox {
  background-color: #fff;
  min-height: calc(100vh - 80px);
  // height: 100%;
  .tablelist {
    padding: 0 30px 30px 30px;
    min-height: calc(100vh - 360px) !important;
  }
}

::v-deep .el-table {
  height: 100%;
  .el-table__body-wrapper {
    overflow: hidden;
    position: relative;
    height: calc(100% - 80px);
  }
}

.InsuranceSelect {
  padding: 30px 30px 0;
}

::v-deep .el-select .el-input__inner {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-col-20 {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-row {
  margin-left: 0 !important;
}
.el-select {
  width: 224px;
}
.el-input--suffix {
  width: 224px;
}
.el-button--small {
  width: 92px;
  height: 40px;
}
::v-deep .el-input--medium .el-input__inner {
  height: 40px;
}
</style>
